import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StockProjectionRoutingModule } from './stock-projection-routing.module';
import { StockProjectionComponent } from './stock-projection.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { DxButtonModule, DxChartModule, DxCheckBoxModule, DxDataGridModule, DxPopupModule, DxRangeSelectorModule, DxSwitchModule, DxTextBoxModule } from 'devextreme-angular';
import { DropDownFilterModule } from 'src/app/widgets';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { FormsModule } from '@angular/forms';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';


@NgModule({
  declarations: [StockProjectionComponent],
  imports: [
    CommonModule,
	DxTableControllerDirective,
    StockProjectionRoutingModule,
    FiltersGroupModule,
    DxChartModule,
    DropDownFilterModule,
    DxTextBoxModule,
    DxRangeSelectorModule,
    DxButtonModule,
    BookmarkModule,
    DxDataGridModule,
    DxPopupModule,
    DxCheckBoxModule,
    FormsModule,DevEpressCommonModule,DxSwitchModule,WebExportModule
  ]
})
export class StockProjectionModule { }
